import React, {useEffect, useState, useRef, useMemo} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import MeChildHeader from '../../components/me-child-header'
import { action_fetch_coupons, action_fetch_show_redeem } from '../../../../../store/actions/pages/customer'
import { useStore, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import MeLoading from '../../components/loading'
import { useDispatch } from 'react-redux'
import { FormattedMessage, useIntl } from 'react-intl'
import { CouponList } from './components/coupone-list'
// import ShareCoupon from '../../../../layout/fragments/share-coupon'
import { GiftCard } from '../../../../layout/fragments/black-coupon-alert'
import ProductShare from '../../../details/components/product-share/index'

const CouponTabs = props => {
    useStyles(classes)
    const {showType, setShowType} = props

    return (
        <div className={classes.TabsBox}>
            <div className={`${classes.TabItem}`} onClick={() => setShowType('unused')}>
                <span className={`${showType == 'unused' ? classes.TabSelect: ''}`}>
                    <FormattedMessage id="unused" defaultMessage={'Unused'}/>
                </span>
            </div>
            <div className={`${classes.TabItem}`} onClick={() => setShowType('expired')}>
                <span className={`${showType == 'expired' ? classes.TabSelect: ''}`}>
                    <FormattedMessage id="expired" defaultMessage={'Expired'}/>
                </span>
            </div>
        </div>
    )
}
const CouponExpiringTabs = props => {
    useStyles(classes)
    const {showExpiringType, setShowExpiringType} = props

    return (
        <div className={classes.ExpiringTabsBox}>
            <div className={`${classes.ExpiringTabItem} ${showExpiringType == 'all' ? classes.ExpiringTabItem2: ''}`} onClick={() => setShowExpiringType('all')}>
                <span className={`${showExpiringType == 'all' ? classes.ExpiringAllTabSelect: ''}`}>
                    <FormattedMessage id="all" defaultMessage={'ALL'}/>
                </span>
            </div>
            <div className={`${classes.ExpiringTabItem} ${showExpiringType == 'expiring' ? classes.ExpiringTabItem2: ''}`} onClick={() => setShowExpiringType('expiring')}>
                <span className={`${showExpiringType == 'expiring' ? classes.ExpiringTabSelect: ''}`}>
                    <FormattedMessage id="expiring_soon" defaultMessage={'Expiring Soon'}/>
                </span>
            </div>
        </div>
    )
}

const CouponsPage = props => {
    useStyles(classes)

    const pageCustomer = useSelector(state => state.pageCustomer)
    const { customer, coupons, expiredCoupon, showRedeemCoupon } = pageCustomer || {}

    const dispatch = useDispatch()
    const Intl = useIntl()
    const store = useStore()
    const params = useParams()
    const query = useQuery()
    const history = useHistory()

    const [showType, setShowType] = useState("unused")
    const [loading, setLoading] = useState(true)

    const [showShare, setShowShare] = useState(false)
    const [showShareCoupon, setShowShareCoupon] = useState(null)
    const [showExpiringType, setShowExpiringType] = useState("all")

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            if(!coupons?.unused){
                await CouponsPage.fetchData(store, params, query)
            }
		}
    }, [])

    useEffect(() => {
        if(coupons?.unused){
            setLoading(false)
        } else {
            setTimeout(() => {
                setLoading(false)
            }, 5000)
        }
    },[coupons])

    const changeType = (type) => {
        setLoading(true)
        if(!expiredCoupon?.loading){
            switch(type){
                case 'unused':
                    setShowType('unused')
                    setLoading(false)
                    break;
                case 'expired':
                    setShowType('expired')
                    if(!coupons?.['expired']){
                        dispatch(action_fetch_coupons('expired',0)).then(res => {
                            setLoading(false)
                        })
                    } else {
                        setLoading(false)
                    }
                    break;
                default:
                    setLoading(false)
                    break;
            }
        }
    }
    const changeExpiringType=(type)=>{
        setShowExpiringType(type);
    }
    const showList = useMemo(() => {
        return coupons?.[showType]
    }, [showType, coupons])

    return <div classes={classes.CouponsPage}>
        <div className={classes.CouponsHeader}>
            <MeChildHeader name={" "}/>
            <CouponTabs
                showType={showType}
                setShowType={(e) => changeType(e)}
                />
            {
                showType=="unused"&&<CouponExpiringTabs
                    showExpiringType={showExpiringType}
                    setShowExpiringType={(e) => {
                        changeExpiringType(e)
                    }}
                />
            }
        </div>

        <div>
            <CouponList
                showType={showType}
                showExpiringType={showExpiringType}
                list={showList}
                loading={showType == 'unused' ? loading: expiredCoupon?.loading}
                finished={showType == 'unused' ? showList?.length == 0 : expiredCoupon?.finished}
                showRedeemCoupon={showRedeemCoupon}
                toRedeem={()  => {
                    history.push('/user/redeem-coupon')
                }}
                request={() => {
                    dispatch(action_fetch_coupons('expired',0))
                }}
                toShare={(coupon) => {
                    if(window.GeekoSensors){
                        window.GeekoSensors.Track("GiftCardShare",{
                            button: `clickshare`,
                        })
                    }
                    setShowShareCoupon(coupon)
                }}
            />
        </div>

        <MeLoading loading={loading} />

        {/* <ShareCoupon show={!!showShareCoupon} coupon={showShareCoupon} handleClose={() => setShowShareCoupon(null)}/> */}

        <ProductShare
            showShareModal={showShareCoupon}
            fetchParams={{urlCode: 'CPN0', params: JSON.stringify({ couponId: showShareCoupon?.id, couponMouldId: showShareCoupon?.couponMouldId })}}
            onClose={() => setShowShareCoupon(null)}
            isShare={true}
            >
            <div className={classes.GiftCardShareBox}>
                <GiftCard coupon={showShareCoupon} toShare={() => {}}/>
            </div>
        </ProductShare>
    </div>
}

CouponsPage.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_coupons('unused',0,headers))
    await store.dispatch(action_fetch_show_redeem(headers))
}

export default CouponsPage